import Validators from '../validators'

export default (store) => store.createEmbededEntityState({
  attrs: ['country', 'value'],
  titles: [store.__('country'), store.__('date')],
  _sortField: 'country',
  attributesFilter: { key: 'name', value: 'hsvd' },
  initVals: (row) => {
    return {
      name: 'hsvd'
    }
  },
  validators: {
    value: Validators.isMandatory(store),
    country: Validators.isMandatory(store)
  }
})
